import { PaginationType, TicketType, userType } from "../../DTO";
import { Api } from "../api";
import { convertToPaginationType } from "../help";

export const ListTickets = (
    user: userType,
    page: number,
    filters?: { department_id?: number; status_id?: number; user_id?: number },
) => {
    return new Promise<{ tickets: TicketType[]; pagination: PaginationType }>(
        (resolve, reject) => {
            const api = new Api({
                method: "get",
                path: "tickets",
                header: {
                    Authorization: `Bearer ${user.access_token}`,
                },
                params: {
                    page,
                    ...(filters?.department_id
                        ? { department_id: filters.department_id }
                        : {}),
                    ...(filters?.status_id
                        ? { status_id: filters.status_id }
                        : {}),
                    ...(filters?.user_id ? { user_id: filters.user_id } : {}),
                },
            });

            return api
                .call()
                .then((data: any) => {
                    resolve({
                        tickets: data.data.data,
                        pagination: convertToPaginationType(data.data),
                    });
                })
                .catch((err: any) => reject(err?.data?.message ?? err));
        },
    );
};
